/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ContentStudioConfigStudyProgram } from './contentStudioConfigStudyProgram';

/**
 * Structural configuration for the module generation.
 */
export interface ContentStudioConfig {
  /** Number of levels (weeks/units) to generate (2-10). */
  levels?: number;
  /** Total number of tasks to generate across all levels. */
  totalTasks?: number;
  /** Target difficulty level (bachelor, master, professional). */
  difficulty?: string;
  /** Optional name of the study program for context. */
  studyProgram?: ContentStudioConfigStudyProgram;
}
